/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-05-29",
    versionChannel: "nightly",
    buildDate: "2023-05-29T00:19:07.550Z",
    commitHash: "0955ab40e67d4668f3ebd5fbdf3602750e35abb8",
};
